/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

const base = {
    excel_pending: false,
    excel_spreadsheet_url: null,
    excel_spreadsheet_downloaded: false,
    pending: false,
    copy_id: null,
    copy_saving: false,
    copy_name: '',
    copy_pending: false,
    copy_success: false,
    copy_message: null,
    management: {
        privileges: [],
        invites: []
    },
    versions: {
        current_version: null,
        data: [],
        managementeta: {}
    },
    data: {},
    meta: {
        tabs: []
    }
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(base)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/state.js